import casesAPI from '@/api/resources/cases'
import servicesAPI from '@/api/resources/services'
// import inventoriesAPI from '@/api/resources/inventories'
import usersAPI from '@/api/user'
import consts from '@/config/consts'
import itemTypesMixins from '@/mixins/ItemTypes'

export default {
  mixins: [ itemTypesMixins ],
  computed: {
    itemTypeToItemIDMap () {
      return {
        [consts.schedules.INVENTORY_TYPE_ID]: this.selectedInventory,
        [consts.schedules.SERVICE_TYPE_ID]: this.selectedService,
        [consts.schedules.CASEMANAGER_TYPE_ID]: this.selectedCaseManager
      }
    },
    itemTypeIDInDBToEntitiesListNameMap () {
      return {
        [consts.schedules.INVENTORY_TYPE_ID]: 'inventoriesList',
        [consts.schedules.SERVICE_TYPE_ID]: 'servicesList',
        [consts.schedules.CASEMANAGER_TYPE_ID]: 'caseManagersList'
      }
    },
    entitiesListNameToSelectedEntityNameMap () {
      return {
        'inventoriesList': 'selectedInventory',
        'servicesList': 'selectedService',
        'caseManagersList': 'selectedCaseManager'
      }
    },
    listsMap () {
      return {
        'inventoriesList': this.inventoriesList,
        'servicesList': this.servicesList,
        'caseManagersList': this.caseManagersList
      }
    },
    entitiesSelectedMap () {
      return {
        'selectedInventory': this.selectedInventory,
        'selectedService': this.selectedService,
        'selectedCaseManager': this.selectedCaseManager
      }
    },
    itemTypeToListsMap () {
      return {
        [consts.schedules.INVENTORY_TYPE_ID]: this.inventoriesList,
        [consts.schedules.SERVICE_TYPE_ID]: this.servicesList,
        [consts.schedules.CASEMANAGER_TYPE_ID]: this.caseManagersList
      }
    }
  },
  mounted () {
    casesAPI.loadActiveCases().then(result => {
      this.casesList = result
    }, () => {})

    /*
    inventoriesAPI.loadInventories().then(result => {
      this.inventoriesList = result
    }, () => {})
    */

    servicesAPI.loadServices().then(result => {
      console.log('got services', result)
      this.servicesList = result
    }, () => {})

    usersAPI.loadCaseManagers().then(result => {
      this.caseManagersList = result
    }, () => {})
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Bookings.js